$(function(){

  // ヘッダーメニューの開閉
  {
    const $btn = $('.add_header_btn');

    $btn.click(function(){
      const index = $btn.index(this);
      const $menus = $('.add_header_menu');
      const $this_menu = $menus.eq(index);

      // メニューを閉じる
      if($(this).hasClass('add_header_btn_active')){
        $(this).removeClass('add_header_btn_active');  
        $this_menu.fadeOut(200);
      }
      // メニューを開く
      else{
        $btn.removeClass('add_header_btn_active');
        $(this).addClass('add_header_btn_active');
        $menus.fadeOut(200);
        $this_menu.fadeIn(200);
      }
    });
  }


  // どこポイのポイント入力時、価格を引く
  {

    // ポイントを常に監視して更新
    setInterval(function(){
      const $point = $('#dokopoiUsePointResult');
      const point = $point.text().replace(",","");
      const $point_price = $('#add_cart_total_usepoint');
      const $total_price = $('#add_cart_total');
      const total_price = $total_price.find("span").text().replace(/¥|,/g,"");

      if(point > 0){
        $total_price.addClass('add_cart_total_cancel');
        const point_price = '¥' + (total_price - point).toLocaleString();
        $point_price.find("span").text(point_price);
        $point_price.show();
      }
      else{
        $total_price.removeClass('add_cart_total_cancel');
        $point_price.hide();
      }
      
    },1000);

    // リセットボタン押したとき
    $(document).on('click', "#dokopoiReset", function(){
      $('#dokopoiUsePointResult').text(0);
    });

  }


  // 商品ページのスライダー
  {
    // .swiperクラスが存在する場合に実行
    if ($('.swiper').length > 0) {

      const swiper = new Swiper(".swiper-sub", {
        spaceBetween: 10,
        slidesPerView: 5,
        breakpoints: { 
          1139: { // 画面幅x以上で適用
            slidesPerView: 10,
          }
        }
      });
      
      const swiper2 = new Swiper(".swiper-main", {
        thumbs: {
          swiper: swiper
        }
      });

    }

  }
 
});























